<template>
  <div class="archival">
    <header class="header">
      <div class="container">
        <h1 class="title">Archiwum wyników</h1>
      </div>
    </header>

    <ul class="groups" v-if="fetchStatus === 'fetched'">
      <li v-for="group in notEmptyGroups" :key="group.id" class="group">
        <div class="group__label">{{ group.short }}</div>
        <h2 class="group__name">{{ group.fullName }}</h2>

        <div class="years">
          <button
            class="year"
            @click="selectedCompetitions = getGroupIdCompetitionsByYear(group.id, year)"
            v-for="year in getYearsByGroupId(group.id)"
            :key="year"
          >
            {{ year }}
          </button>
        </div>
      </li>
    </ul>

    <CompetitionsModal
      v-if="selectedCompetitions"
      :title="'Wybierz zawody'"
      :compViews="selectedCompetitions"
      @close-modal="selectedCompetitions = null"
    />
  </div>
</template>

<script>
import CompetitionsModal from "@/components/CompetitionsModal"
import { config } from "@/config"

export default {
  name: "Archival",

  components: {
    CompetitionsModal,
  },

  data: () => ({
    groups: null,
    groupsFetchStatus: null,

    competitions: null,
    competitionsFetchStatus: null,

    selectedCompetitions: null,
  }),

  computed: {
    fetchStatus: function () {
      if (this.groupsFetchStatus === "fetched" && this.competitionsFetchStatus === "fetched") {
        return "fetched"
      }

      if (this.groupsFetchStatus === "error" || this.competitionsFetchStatus === "error") {
        return "error"
      }

      return null
    },
    notEmptyGroups: function () {
      return this.groups.filter((group) => this.getYearsByGroupId(group.id).length > 0)
    },
  },

  methods: {
    getCompetitionsByGroupId: function (groupId) {
      return this.competitions?.filter((competition) => competition.archivalGroupId === groupId)
    },

    getGroupIdCompetitionsByYear: function (groupId, year) {
      return this.competitions?.filter(
        (compView) => compView.archivalGroupId === groupId && compView.competition.year === year
      )
    },

    getYearsByGroupId: function (groupId) {
      const availableYears = this.getCompetitionsByGroupId(groupId).map((compView) => compView.competition.year)
      const uniqYears = [...new Set(availableYears)].sort((a, b) => parseInt(a) - parseInt(b))
      return uniqYears
    },

    getGroups() {
      fetch(`${config.ManagerServer.rest.url}/archivalGroups`)
        .then((response) => {
          if (response.ok) return response.json()
          throw new Error("Error loading data")
        })
        .then((data) => {
          this.groups = data
          this.groupsFetchStatus = "fetched"
        })
        .catch(() => (this.groupsFetchStatus = "error"))
    },

    getCompetitions() {
      fetch(`${config.ManagerServer.rest.url}/archivalView`)
        .then((response) => {
          if (response.ok) return response.json()
          throw new Error("Error loading data")
        })
        .then((data) => {
          this.competitions = data
          this.competitionsFetchStatus = "fetched"
        })
        .catch(() => (this.competitionsFetchStatus = "error"))
    },
  },

  created() {
    this.getGroups()
    this.getCompetitions()
  },
}
</script>

<style lang="scss" scoped>
.header {
  background: #fff;
  padding: 2rem;
}

.title {
  font-size: 1.5rem;
  font-weight: 800;
  text-transform: uppercase;
  margin: 0;
}

.groups {
  margin: 2rem;
}

.group {
  color: #fff;
  padding: 2rem;
  background: #000;

  & + .group {
    margin-top: 2rem;
  }
}

.years {
  .year {
    font-size: 1rem;
    font-weight: bold;
    background: #fff;
    padding: 1rem 1.5rem;
    min-width: 10rem;

    &:hover {
      background: #eee;
    }

    & + .year {
      margin-left: 1rem;
    }
  }
}
</style>
